import { SVGProps } from "react";

export function Process(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="#00597a"
      data-testid="process-icon"
      {...props}
    >
      <path d="M4.00293 12.0001C4.00299 13.8655 4.6553 15.6722 5.84668 17.1075C7.03811 18.5429 8.69385 19.5169 10.5273 19.8605C12.3607 20.2039 14.2566 19.8959 15.8867 18.9894C17.1573 18.2827 18.203 17.2459 18.9229 16.0001H17V14.0001H21C21.5523 14.0001 22 14.4478 22 15.0001V19.0001H20V17.9972C19.1632 19.1134 18.0971 20.0515 16.8604 20.7394C14.8218 21.8731 12.4509 22.2588 10.1582 21.8292C7.86558 21.3996 5.79546 20.1816 4.30566 18.3868C2.81589 16.592 2.00006 14.3327 2 12.0001H4.00293Z" />
      <path d="M9 15.0001H7V12.0001H9V15.0001Z" />
      <path d="M12 15.0001H10V10.0001H12V15.0001Z" />
      <path d="M15 15.0001H13V7.00012H15V15.0001Z" />
      <path d="M7.13965 3.26086C9.17821 2.12713 11.5491 1.74143 13.8418 2.17102C16.1344 2.60062 18.2045 3.81862 19.6943 5.6134C21.1841 7.40828 22 9.66751 22 12.0001H19.9971C19.997 10.1347 19.3447 8.32808 18.1533 6.8927C16.9619 5.45732 15.3062 4.48333 13.4727 4.13977C11.6393 3.79629 9.74343 4.10436 8.11328 5.01086C6.84266 5.71753 5.79698 6.75435 5.07715 8.00012H7V10.0001H3C2.44772 10.0001 2 9.55241 2 9.00012V5.00012H4V6.00305C4.83682 4.88681 5.90286 3.94871 7.13965 3.26086Z" />
    </svg>
  );
}
